'use strict';

const changeLastNotification = ({ commit }, notification) => {
  commit('changeLastNotification', notification);
};

export default {
  changeLastNotification
};
